import type { ActionMessage } from '../types';
import { invokeAction } from './invoke';

export type PageLoadedAction = ActionMessage<'pageLoaded'>;

export const pageLoaded = invokeAction('uniclientAction', 'pageLoaded');
